import { useEffect, useState, useRef } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate } from "react-router-dom";
import "./App.css";
import {
  AuthCallBack,
  ExistingCustomerAuthentication,
  NewCustomerAuthentication,
  SalesPersonAuthentication,
} from "./Component/Authentication";
import { MainHomeScreen, MainImage } from "./Component/HomeScreen";
import { TopNavHeader } from "./Component/Header";
import HomeScreen from "./Component/MainHomePage/HomeScreen";
import { MainCartPage } from "./Component/Pages";
import { MainAmazonInventory, MainInventory } from "./Component/Inventory";
import BreadCrumb from "./Component/BreadCrumb/BreadCrumb";
import axios from 'axios'
import {
  MainAtuReplenishment,
  MainReplenishment,
} from "./Component/AtuReplenishment";
import { MainClientInformation } from "./Component/ClientInformation";
import Validation from "./Validation";
import { MainRecentOrder } from "./Component/RecentOrder";
import { CopyrightFooter } from "./Component/Footer";
import MainIncoming from "./Component/Inventory/MainIncoming";
import { SearchProvider } from './Context/SetGlobalSearch'; // Import SearchProvider
import { FaqComponent, PageNotFound, RefreshPage } from "./Component/ExternalComponent";
import { QrCodeScanner, QrGenerate } from "./Component/QRScanner";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useCartAccountContext } from "./Context/Cache/CartAccount/CartAccountContext";
import { useTokenCallContext } from "./Context/TokenCall";

// import AutoRefreshPopup from "./Component/ExternalComponent/SubComponent/AutoRefreshPopup";
function App() {
  const { accountCacheName } = useCartAccountContext()
  const {currentUrl} = useTokenCallContext()
  const [shouldRedirect, setShouldRedirect] = useState(false); 
  const [showPopup, setShowPopup] = useState(false);
  const [timeLeft, setTimeLeft] = useState(600); // 60 seconds = 1 minute
  const [isActive, setIsActive] = useState(true); // Timer starts automatically after refresh
  const [isTimeUp, setIsTimeUp] = useState(false); // Track if the countdown reached 0
  const timeoutRef = useRef(null);
  const validWithOTP = localStorage.getItem("validWithOTP") === "true";
  const validSalesPerson = localStorage.getItem("validSalesPerson") === "true";
  const validNewPerson = localStorage.getItem("validNewCustomer") === "true";

  const handleInvalidToken = () => {
    // caches.delete(accountCacheName);
    caches.keys().then(names => {
      names.forEach(name => {
        if (name !== 'cart-product-cache') {
          caches.delete(name);
        }
      });
    });    
    localStorage.clear();
    sessionStorage.clear(); // Clear sessionStorage for the current tab
    setTimeout(() => {
      window.location.href = "/";
    }, 3000);
    // Clear localStorage
    window.localStorage.setItem('clearSessionStorage', Date.now());
  };

  useEffect(() => {
    // Listener to clear sessionStorage in other tabs
    const handleStorageChange = (event) => {
      if (event.key === 'clearSessionStorage') {
        sessionStorage.clear(); // Clear sessionStorage when signaled
      }
    };

    // Add the listener for storage changes
    window.addEventListener('storage', handleStorageChange);

    // Cleanup the listener on component unmount
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  useEffect(() => {
    const validateSession = () => {
      const token = localStorage.getItem('120MinToken');
      if (!token && validWithOTP) {
        // toast.warning("Your session has expired. Please log in again.");
        handleInvalidToken();
      }
    };
    
    const timeoutId = setTimeout(validateSession, 100); // Adjust delay as needed
    
    return () => clearTimeout(timeoutId); // Cleanup timeout on component unmount
  }, [validWithOTP]);
  
  

  useEffect(() => {
    // Retrieve token, email, and flags
    const token = localStorage.getItem('120MinToken');
    const newUserValidation = localStorage.getItem('newUserValidation') === 'true';
    const newUserEmail = sessionStorage.getItem('NewUserEmail');

    // Only proceed with validation if the token exists
    if (!token && validWithOTP) {
      // toast.error("Your session has expired. Please log in again.");
      handleInvalidToken(); 
      return;
    }

    // Function to validate the token
    const validateToken = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_SERVER_URL}/api/auth/verify/validate-token`,
          { token }
        );

        if (response.data.message === 'Token is valid') {
          return; // Token is valid, no action needed
        } else {
          // toast.warning("Your session has expired. Please log in again.");
          handleInvalidToken(); 
        }
      } catch (error) {
        console.log("Error", error);
      }
    };

    // Function to validate the token and check email for new users
    // const newUserValidateToken = async () => {
    //   try {
    //     const response = await axios.post(
    //       `${process.env.REACT_APP_SERVER_URL}/api/auth/verify/validate-token`,
    //       { token }
    //     );

    //     const { message } = response.data;
    //     const { email } = response.data.data;

    //     // Check if token is valid and email matches the expected newUserEmail
    //     if (message === 'Token is valid' && email === newUserEmail) {
    //       return; // Valid token and email match, no action needed
    //     } else {
    //       handleInvalidToken(); // Token invalid or email mismatch, trigger invalidation
    //     }
    //   } catch (error) {
    //     toast.error("Error validating token: " + error);
    //     console.error("Error validating token:", error);
    //   }
    // };

    const newUserValidateToken = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_SERVER_URL}/api/auth/verify/validate-token`,
          { token }
        );
        const { message } = response.data;
        // Add a defensive check before destructuring
        if (response.data.data) {
          const { email } = response.data.data;
          // Further logic related to email
          if(email === newUserEmail){
            return
          } else {
            handleInvalidToken();
          }
        } else {
          console.warn('Email data is undefined');
          handleInvalidToken(); // Handle as an invalid token
        }
   
        // Additional token validation logic if needed
        if (message !== 'Token is valid') {
          handleInvalidToken(); // Handle as an invalid token
        }
   
      } catch (error) {
        console.error("Error", error);
        //handleInvalidToken(); // Optionally, handle token error here too
      }
    };
    
    // Conditional validation based on flags
    if (validWithOTP && newUserValidation) {
      newUserValidateToken(); 
    } else if (validWithOTP) {
      validateToken();
    }
  }, [validWithOTP, validNewPerson, currentUrl]);

  useEffect(() => {
    // Automatically start the countdown after refresh
    const startCountdown = () => {
      setIsActive(true); // Set countdown to active immediately
    };

    const handleMouseMove = () => {
      clearTimeout(timeoutRef.current); // Reset the inactivity timer
      setTimeLeft(600); // Reset the countdown to 1 minute
      setIsActive(false); // Stop countdown when mouse moves

      // Start the inactivity timer again after no movement for 10 seconds
      timeoutRef.current = setTimeout(() => {
        setIsActive(true); // Start countdown after 10 seconds of inactivity
      }, 10000); // 10 seconds of inactivity to start countdown
    };

    // Start the countdown automatically when the page loads or refreshes
    startCountdown();

    // Add mousemove event listener to detect cursor movement
    window.addEventListener('mousemove', handleMouseMove);

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      clearTimeout(timeoutRef.current);
    };
  }, []);

  useEffect(() => {
    let interval = null;

    if (isActive && timeLeft > 0) {
      // Start countdown
      interval = setInterval(() => {
        setTimeLeft((prevTimeLeft) => prevTimeLeft - 1);
      }, 1000); // Countdown every second
    } else if (timeLeft === 0) {
      clearInterval(interval); // Stop countdown at 0
      setIsTimeUp(true); // Set flag when time is up
    }

    return () => clearInterval(interval);
  }, [isActive, timeLeft]);


  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };


  // If the countdown reaches 0, display the RefreshPage component
  if (isTimeUp) {
    return <RefreshPage />;
  }

  return (
    <Router>
      {validWithOTP && <TopNavHeader />}
      {/* <p className="text-gray-700 mb-0.5">Time left: {formatTime(timeLeft)}</p> */}
      <Routes>
        {validWithOTP && validSalesPerson && validNewPerson && (
          <>
            <Route path="/" element={<Navigate to="/home/inventory" replace />} />
            <Route path="*" element={<MainInventory />} />
            <Route path="/home/cart" element={<MainCartPage />} />
            <Route path="/home/inventory" element={<MainInventory />} />
            <Route path="/home/amazon-inventory" element={<MainAmazonInventory />} />
            <Route path="/home/incoming" element={<MainIncoming />} />
            {/* <Route path="/home/atu" element={<MainAtuReplenishment />} /> */}
            {/* <Route path="/home/replenishment" element={<MainReplenishment />} /> */}
            <Route path="/home/recent-orders" element={<MainRecentOrder />} />
            <Route path="/help-support" element={<FaqComponent />} />
            <Route path="/client-information" element={<MainInventory />} />
            {/* <Route path="*" element={<PageNotFound />} /> Catch-all route */}
          </>
        )}
        {validWithOTP && !validSalesPerson && validNewPerson && (
          <>
            <Route path="/client-information" element={<MainClientInformation />} />
            {/* <Route path="*" element={<PageNotFound />} /> Catch-all route */}
            <Route path="*" element={<MainClientInformation />} />
          </>
        )}
        {validWithOTP && !validSalesPerson && !validNewPerson && (
          <>
            <Route path="/" element={<Navigate to="/home/inventory" replace />} />
            <Route path="*" element={<MainInventory />} />
            <Route path="/home/cart" element={<MainCartPage />} />
            <Route path="/home/inventory" element={<MainInventory />} />
            <Route path="/home/amazon-inventory" element={<MainAmazonInventory />} />
            <Route path="/home/incoming" element={<MainIncoming />} />
            {/* <Route path="/home/atu" element={<MainAtuReplenishment />} /> */}
            <Route path="/home/recent-orders" element={<MainRecentOrder />} />
            {/* <Route path="*" element={<PageNotFound />} /> Catch-all route */}
            <Route path="/help-support" element={<FaqComponent />} />
            {/* <Route path="/home/replenishment" element={<MainReplenishment />} /> */}
          </>
        )}
        {!validWithOTP && (
          <>
            <Route path="/" element={<MainHomeScreen />} />
            <Route path="*" element={<MainHomeScreen />} />
            <Route path="/new-customer" element={<NewCustomerAuthentication />} />
            <Route path="/existing-customer" element={<ExistingCustomerAuthentication />} />
            <Route path="/sales-person" element={<SalesPersonAuthentication />} />
            <Route path="/auth/callback" element={<AuthCallBack />} />
            {/* <Route path="/help-support" element={<FaqComponent />} /> */}
            {/* <Route path="*" element={<PageNotFound />} /> Catch-all route */}
            <Route path="/generate-qrCode" element={<QrGenerate />} />
            <Route path="/scan-qrCode" element={<QrCodeScanner />} />
          </>
        )}
        {/* Default case for any other condition */}
        {!(
          (validWithOTP && validSalesPerson && validNewPerson) ||
          (validWithOTP && !validSalesPerson && validNewPerson) ||
          (validWithOTP && !validSalesPerson && !validNewPerson) ||
          !validWithOTP
        ) && (
            <>
              <Route path="/" element={<MainHomeScreen />} />
              <Route path="*" element={<MainHomeScreen />} />
              <Route path="/new-customer" element={<NewCustomerAuthentication />} />
              <Route path="/existing-customer" element={<ExistingCustomerAuthentication />} />
              <Route path="/sales-person" element={<SalesPersonAuthentication />} />
              <Route path="/auth/callback" element={<AuthCallBack />} />
              {/* <Route path="*" element={<PageNotFound />} /> Catch-all route */}
              <Route path="/generate-qrCode" element={<QrGenerate />} />
              <Route path="/scan-qrCode" element={<QrCodeScanner />} />
            </>
          )}
      </Routes>
    </Router>
  );
}
export default App;